import { LazyImport, LazyModule, createLazyComponent, LazyAction } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';

export { default as getPresenceFromStore } from './presenceManager/getPresenceFromStore';
export { default as isSignedIn } from './presenceManager/isSignedIn';
export { default as StartChatSource } from './store/schema/StartChatSource';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "SkypeForBusiness", webpackPrefetch: true */ './lazyIndex')
);

const lazyInitializeSkypeForBusiness = new LazyImport(
    lazyModule,
    m => m.initializeSkypeForBusiness
);

// Export initialize skype (UCMA/UCWA) function
export function initializeSkypeForBusiness() {
    if (isFeatureEnabled('fwk-skypeBusinessV2')) {
        lazyInitializeSkypeForBusiness
            .import()
            .then(initializeSkypeForBusiness => initializeSkypeForBusiness());
    }
}

// Export delay loaded functions
export let lazyTryRegisterForPresenceUpdates = new LazyImport(
    lazyModule,
    m => m.tryRegisterForPresenceUpdates
);

export let lazyStartChat = new LazyImport(lazyModule, m => m.startChat);
export let lazySetIsChatCalloutShown = new LazyAction(lazyModule, m => m.setIsChatCalloutShown);

export let UcmaChatView = createLazyComponent(lazyModule, m => m.UcmaChatView);
